import { render } from "./CommentImage.vue?vue&type=template&id=11a39248"
import script from "./CommentImage.vue?vue&type=script&lang=js"
export * from "./CommentImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__